// extracted by mini-css-extract-plugin
module.exports = {"cover":"LandingPageCover_cover__npUYr","img":"LandingPageCover_img__pC1Q7"};